export default defineNuxtRouteMiddleware((to) => {
  const { $enabled } = useNuxtApp();

  if (!$enabled('website.enablefreeplay'))
    return navigateTo(`/${to.params.contentType}`);
});
